__turbopack_context__.v({
  "benefit": "-GJ_Aq_benefit",
  "bottom": "-GJ_Aq_bottom",
  "h3": "-GJ_Aq_h3",
  "image": "-GJ_Aq_image",
  "img__z2Tfa": "-GJ_Aq_img__z2Tfa",
  "p": "-GJ_Aq_p",
  "top": "-GJ_Aq_top",
});
